export function validateIBAN(iban: string): boolean {
  if (!iban) return false;

  const cleaned = iban.replace(/\s+/g, "").toUpperCase();

  // minimum length
  if (cleaned.length < 5) return false;

  // 1️⃣ przenieś 4 pierwsze znaki na koniec
  const rearranged = cleaned.slice(4) + cleaned.slice(0, 4);

  // 2️⃣ zamiana liter na liczby
  const numeric = rearranged
    .split("")
    .map((char) => {
      const code = char.charCodeAt(0);
      if (code >= 65 && code <= 90) {
        return (code - 55).toString(); // A=10, B=11...
      }
      return char;
    })
    .join("");

  // 3️⃣ modulo 97 (na dużych liczbach robimy chunkami)
  let remainder = numeric;
  while (remainder.length > 2) {
    const block = remainder.slice(0, 9);
    remainder = (parseInt(block, 10) % 97).toString() + remainder.slice(block.length);
  }

  return parseInt(remainder, 10) % 97 === 1;
}